import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20cream%20textured%20abstract%20background%20with%20delicate%20floral%20elements%2C%20subtle%20rose%20gold%20accents%2C%20minimalist%20elegant%20composition%2C%20gentle%20gradient%20from%20warm%20beige%20to%20soft%20blush%2C%20artistic%20watercolor%20style%2C%20feminine%20sophisticated%20atmosphere&width=1800&height=900&seq=hero-bg-main-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <p className="text-background-50/80 text-sm md:text-base font-medium tracking-widest mb-4 uppercase">
          第一次人妻完全指南
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          从容迎接人生
          <br />
          <strong className="text-primary-300">新阶段</strong>
        </h1>
        <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          为初为人妻的你，提供婚姻经营、夫妻沟通、家庭生活与自我成长的实用智慧，做幸福自信的现代妻子。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/newlywed-guide"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            开始阅读指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border border-background-50/40 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}